import { MOCK_CONTRACTS } from './MockContracts'
import { MOCK_METERS } from './MockMeters'
import { MOCK_OPPORTUNITIES } from './MockOpportunities'
import { MOCK_ORDERS } from './MockOrders'

export const MOCK_CONTRACTS_FOR_SEARCH = MOCK_CONTRACTS.map((contract) => ({
  ...contract,
  meters: [MOCK_METERS[0]],
  order: [MOCK_ORDERS[0]]
}))

export const MOCK_METERS_FOR_SEARCH = MOCK_METERS.map((meter) => ({
  ...meter,
  contract: [MOCK_CONTRACTS[0]]
}))

export const MOCK_OPPORTUNITIES_FOR_SEARCH = MOCK_OPPORTUNITIES.map(
  (opportunity) => ({
    ...opportunity,
    orders: MOCK_ORDERS
  })
)

export const MOCK_ORDERS_FOR_SEARCH = MOCK_ORDERS
